const Desc = `smartObjectV2: psb input file in aws, replace high res image. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'https://skycity-asset.adobedice.com/testing/pits/input/AUTOBLUR_l_small.psb',
            storage: 'external'
        }
    ],
    options: {
        layers: [
            {
                name: 'REPLACE_ME',
                input: {
                    href: 'files/_skycity_smoketest/Seeing Chanel_small.png',
                    storage: 'adobe'
                }
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/png',
            overwrite: true,
            width: 300,
            compression: 'small'
        }
    ]
}

module.exports = { Payload, Desc }
